<template>
    <div>
        <AdminSnackbar />
        <AdminNavigation />
        <AdminHeader />
        <v-content>
            <div class="ma-4">
                <router-view></router-view>
            </div>
        </v-content>
      <AdminFooter/>
    </div>
</template>
<script>
import AdminNavigation from './AdminNavigation'
import AdminHeader from './AdminHeader'
import AdminFooter from './AdminFooter'
import AdminSnackbar from './AdminSnackbar'

export default {
  name: 'AdminLayout',
  components: {
    AdminNavigation,
    AdminHeader,
    AdminFooter,
    AdminSnackbar
  },
  data: () => ({})
}
</script>
